import { render } from "./GridCommandCell.vue?vue&type=template&id=ca36b5a4"
import script from "./GridCommandCell.vue?vue&type=script&lang=js"
export * from "./GridCommandCell.vue?vue&type=script&lang=js"
script.render = render

export default script